export default "__VITE_ASSET__96f3669f__"